"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_2 = require("@fluentui/react");
require("./CustomLabel.scss");
require("./Forms.scss");
require("./HelperButton.scss");
exports.HelperButton = function (props) {
    var children = props.children;
    var _a = react_1.useState(), helpTextOpen = _a[0], setHelpTextOpen = _a[1];
    var helpIconId = react_2.getId('helpIcon');
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "eta-info" },
            react_1.default.createElement(react_2.Icon, { id: helpIconId, iconName: "info", onClick: function () { return setHelpTextOpen(true); } })),
        helpTextOpen && (react_1.default.createElement(react_2.Callout, { target: "#" + helpIconId, onDismiss: function () { return setHelpTextOpen(false); }, gapSpace: 0, setInitialFocus: true },
            react_1.default.createElement("div", { className: "eta-helperText" }, children)))));
};
//# sourceMappingURL=HelperButton.js.map